<template>
    <li class="assignment">
        <h6 class="assignment-title">
            {{lpAssignmentIn.name}}
        </h6>
        <b-badge class="assignment-lp-category"
                 pill
                 variant="info">
            {{lpAssignmentIn.lp_category.name}}
        </b-badge>
    </li>
</template>

<script>
export default {
    name: "design-2021-learning-path-current-assignment-component",
    props: {
        lpAssignmentIn: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style scoped lang="scss">
    .assignment {
        padding-bottom: map-get($grid-gutter-spacing, 'fifteen');

        &:not(:first-child){
            border-bottom: 3px dotted $border-color;
            margin-top: map-get($grid-gutter-spacing, 'fifteen');
        }
    }

    .assignment-title {
        margin-bottom: 0;
    }

    .assignment-lpcategory {
        align-self: flex-start;
        font-size: 0.6875rem;
        padding: 3px 8px;
    }
</style>
